/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `dive_gas` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class DiveGasMesg : Mesg {
    public constructor() : super("DiveGas", Profile.MesgNum.DIVE_GAS)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** helium_content, in percent. */
    public var heliumContent: UByte?
        get() = getFieldValue(HELIUM_CONTENT_FIELD_NUM) as? UByte
        set(value) = setFieldValue(HELIUM_CONTENT_FIELD_NUM, value)

    /** oxygen_content, in percent. */
    public var oxygenContent: UByte?
        get() = getFieldValue(OXYGEN_CONTENT_FIELD_NUM) as? UByte
        set(value) = setFieldValue(OXYGEN_CONTENT_FIELD_NUM, value)

    /** status. */
    public var status: DiveGasStatus?
        get() = (getFieldValue(STATUS_FIELD_NUM) as? UByte)?.let { DiveGasStatus.fromValue(it) }
        set(value) = setFieldValue(STATUS_FIELD_NUM, value?.value)

    /** mode. */
    public var mode: DiveGasMode?
        get() = (getFieldValue(MODE_FIELD_NUM) as? UByte)?.let { DiveGasMode.fromValue(it) }
        set(value) = setFieldValue(MODE_FIELD_NUM, value?.value)

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val HELIUM_CONTENT_FIELD_NUM: UByte = 0u
        public const val OXYGEN_CONTENT_FIELD_NUM: UByte = 1u
        public const val STATUS_FIELD_NUM: UByte = 2u
        public const val MODE_FIELD_NUM: UByte = 3u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("HeliumContent", 0u, BaseType.UINT8, 1.0, 0.0, "percent", false)
            fields[1] = Field("OxygenContent", 1u, BaseType.UINT8, 1.0, 0.0, "percent", false)
            fields[2] = Field("Status", 2u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[3] = Field("Mode", 3u, BaseType.ENUM, 1.0, 0.0, "", false)
            return fields
        }
    }
}
